export enum CheckoutIntegrationType {
	HYPERSOFT = 'hypersoft',
	MATRIX = 'matrix',
	OMNIVARE = 'omnivore',
	FOOD_GENIUS = 'food_genius',
	NONE = 'none',
	SIMPHONY = 'simphony',
}
